import styled, { css } from 'styled-components';

import { size } from '../layout/helpers';
import { fontBold } from '../layout/font';

export const Wrapper = styled.div`
  display: flex;
  align-items: flex-end;
`;

export const Label = styled.div`
  ${fontBold};
  flex: 1 1 auto;
`;

type ValueProps = React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> & {
  isHighlighted?: boolean;
};

export const Value = styled.div<ValueProps>`
  ${fontBold};
  flex-shrink: 0;
  padding-left: ${size(2)};
  color: var(--element-color, ${(props) => props.theme.color.primary});
  font-size: 1.125rem;

  ${({ isHighlighted }) =>
    isHighlighted &&
    css`
      font-size: 1.375rem;
      color: var(--text-color-primary, ${(props) => props.theme.color.textDark}) !important;
    `}
`;
